// Unpublished Work © 2023-2024 Deere & Company.

import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import ErrorPage from "../../../../components/ErrorPage/ErrorPage";
import NoItemsFoundInfo from "../../../../components/ErrorPage/NoItemsFoundInfo/NoItemsFoundInfo";

const InvoiceLineItemsNoRowsOverlay = ({
  error,
  loading,
  reload,
}: {
  error: boolean;
  loading: boolean;
  reload: () => void;
}) => {
  const { t } = useTranslation(["common", "claims", "invoices"]);

  return (
    <Box
      sx={{
        height: "60vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        {error && (
          <ErrorPage
            title={t("common:technicalError.title")}
            subtitles={[t("common:technicalError.subtitle")]}
            icon={{ Component: WarningAmberIcon, color: "warning" }}
            showBackToHomeLink={false}
            showReloadBtn
            reloadFunction={reload}
          />
        )}
        {!error && !loading && (
          <NoItemsFoundInfo
            itemListName="line items"
            dataTestId="no-invoice-line-items-error"
          />
        )}
      </Box>
    </Box>
  );
};

export default InvoiceLineItemsNoRowsOverlay;
